export var institutions = {
  large_scale_renewable: {
    factor: 3
  },
  small_scale_renewable: {
    factor: 1
  },
  large_scale_efficiency: {
    factor: 3
  },
  electric_utility: {
    factor: 3
  },
  university: {
    factor: 0.5
  },
  consulting_company: {
    factor: 2
  },
  local_government_think_tank: {
    factor: 3
  },
  smart_grid_services: {
    factor: 3
  },
  smart_grid_analytics: {
    factor: 3
  },
  financial: {
    factor: 3
  },
  development_agency: {
    factor: 2
  },
  non_profit: {
    factor: 0.5
  },
  other: {
    factor: 2
  }
};